import { WORKFLOWS } from "../domain/workflows";

export default function WorkflowCards({ onStart, compact = false, items = WORKFLOWS }) {
  return (
    <div className={compact ? "workflow-list" : "workflow-grid"}>
      {items.map(item => (
        <button
          type="button"
          className="workflow-card"
          key={item.id}
          onClick={() => onStart?.(item)}
          disabled={item.available === false}
          aria-disabled={item.available === false}
        >
          {compact && <span className="workflow-icon">{item.short}</span>}
          <span className="workflow-copy">
            <strong>{item.title}</strong>
            <small>{item.available === false ? item.unavailableMessage || "Coming soon." : item.description}</small>
          </span>
          {compact && <span className="chevron">›</span>}
        </button>
      ))}
    </div>
  );
}
